import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FormElement } from "@progress/kendo-react-form";
import LoginAAD from "./LoginAAD";
import LoadingPanel from "../../components/sys-toolbox/LoadingPanel";

export { Login };

function Login() {
  const authUser = useSelector((x) => x.auth.user);
  const isLoading = useSelector((x) => x.auth.isLoading);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (authUser) {
      navigate("/");
    }
  }, []);
  return (
    <div className="login-container">
      <div
        className="form-wrapper"
        // style={{
        //   backgroundColor: "white",
        //   borderRadius:"5%",
        //   margin: "auto",
        //   width: "450px",
        //   height: "250px",
        // }}
      >
        {isLoading && <LoadingPanel />}
        <FormElement
          style={{
            textAlign: "center",
            padding: "10%",
          }}
        >
          <img
            src={window.location.origin + process.env.PUBLIC_URL + "/logo2.png"}
            style={{ maxHeight: "250px", alignSelf: "center" }}
            alt="Daikin"
          ></img>
          <hr></hr>
          <h3 style={{ alignContent: "center", textAlign: "center" }}>
            {t("event_portal")}
          </h3>
          <div>
            <div style={{ display: "grid" }}>
              <LoginAAD></LoginAAD>
            </div>
          </div>
        </FormElement>
      </div>
      <div className="powered-by">
        <p>
          Powered by <strong>DTAS-Corporate Communications</strong> &{" "}
          <strong>DTAS - IT</strong>
        </p>
      </div>
    </div>
  );
}
